import type { ApiClient } from './runtime/apiRuntime';
import { apiMutationOptions, BaseApiMutationOptions } from './apiMutationOptions';
import { apiQueryOptions, BaseApiQueryOptions } from './apiQueryOptions';

export const VideoEditorApi = {
    joinWebinar: (options?: BaseApiMutationOptions<ApiClient['videoEditor']['joinWebinar']>) =>
        apiMutationOptions((api) => api.videoEditor.joinWebinar, options),
    publishWebinar: (options?: BaseApiMutationOptions<ApiClient['videoEditor']['publishWebinar']>) =>
        apiMutationOptions((api) => api.videoEditor.publishWebinar, options),
    getStatus: (webinarId: string, options?: BaseApiQueryOptions) =>
        apiQueryOptions(['videoEditor', 'getStatus', webinarId], (api) => api.videoEditor.getStatus(webinarId), options),
    getKeyframes: (webinarId: string, options?: BaseApiQueryOptions) =>
        apiQueryOptions(['videoEditor', 'getKeyframes', webinarId], (api) => api.videoEditor.getKeyframes(webinarId), options)
};
